import React from "react";
import { Star, ThumbsUp, MessageSquareReply } from "lucide-react";

export default function ReviewCard({
  name,
  date,
  text,
  likes,
  comments,
  avatar,
  rating = 5,
  isLoading = false,
}) {
  if (isLoading) {
    return (
      <div className="p-6 rounded-xl border border-white/10 bg-gradient-to-br from-[#1c2d1f] to-[#1a241c] shadow-md animate-pulse space-y-4">
        {/* Avatar & Name */}
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-gray-700" />
          <div className="flex flex-col gap-2">
            <div className="w-24 h-3 rounded bg-gray-700" />
            <div className="w-16 h-2 rounded bg-gray-700" />
          </div>
        </div>

        {/* Stars */}
        <div className="flex gap-2">
          {Array(5)
            .fill(0)
            .map((_, i) => (
              <div
                key={i}
                className="w-4 h-4 rounded-full bg-gray-700"
              ></div>
            ))}
        </div>

        {/* Text */}
        <div className="space-y-2">
          <div className="h-3 w-full bg-gray-700 rounded" />
          <div className="h-3 w-4/5 bg-gray-700 rounded" />
        </div>

        {/* Actions */}
        <div className="flex justify-between mt-4">
          <div className="flex gap-3">
            <div className="w-4 h-4 bg-gray-700 rounded" />
            <div className="w-4 h-4 bg-gray-700 rounded" />
          </div>
          <div className="w-10 h-3 bg-gray-700 rounded" />
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 rounded-xl border border-white/10 bg-gradient-to-br from-[#1c2d1f] to-[#1a241c] shadow-md hover:shadow-green-500/10 transition duration-300">
      {/* User Info */}
      <div className="flex items-center gap-4 mb-4">
        <img
          src={avatar}
          alt={name}
          className="w-12 h-12 rounded-full object-cover border-2 border-green-400 shadow-sm"
        />
        <div>
          <h3 className="font-semibold text-green-400 text-sm">{name}</h3>
          <p className="text-xs text-gray-400">{date}</p>
        </div>
      </div>

      {/* Stars */}
      <div className="flex gap-1 mb-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star
            key={i}
            className={`${
              i < rating ? "text-green-400 fill-green-400" : "text-gray-600"
            } transition duration-300`}
            size={18}
          />
        ))}
      </div>

      {/* Review Text */}
      <p className="text-sm text-gray-200 leading-relaxed">{text}</p>

      {/* Actions */}
      <div className="mt-4 flex justify-between items-center text-xs text-gray-400">
        <span className="flex items-center gap-3">
          <ThumbsUp className="text-green-400" size={16} />
          <span className="text-sm md:text-base">{likes}</span>
          <MessageSquareReply className="text-green-400" size={16} />
          <span className="text-sm md:text-base">{comments}</span>
        </span>

        <button className="flex items-center gap-1 text-green-400 hover:text-green-300 hover:underline transition">
          <MessageSquareReply size={16} className="md:size-5" />
          <span className="hidden sm:inline-block">Reply</span>
        </button>
      </div>
    </div>
  );
}
